import * as actions from './currentTempSettingActionTypes';

export const setAppBasePath = appBasePath => ({
    type: actions.CURRENT_TEMPSETTING_SET_APPBASEPATH,
    appBasePath
})

